const JSON_WEB_TOKEN_KEY = "jwt";

export const getToken = () => localStorage.getItem(JSON_WEB_TOKEN_KEY);
